/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Global Opt Out Schema
 * @export
 * @interface GlobalOptOut
 */
export interface GlobalOptOut {
    /**
     * Message Channel
     * @type {string}
     * @memberof GlobalOptOut
     */
    channel: GlobalOptOutChannelEnum;
    /**
     * Message Endpoint
     * @type {string}
     * @memberof GlobalOptOut
     */
    endpoint: string;
    /**
     * Opt Out Created Date
     * @type {Date}
     * @memberof GlobalOptOut
     */
    createdDate: Date;
}


/**
 * @export
 */
export const GlobalOptOutChannelEnum = {
    Sms: 'sms',
    Email: 'email'
} as const;
export type GlobalOptOutChannelEnum = typeof GlobalOptOutChannelEnum[keyof typeof GlobalOptOutChannelEnum];


/**
 * Check if a given object implements the GlobalOptOut interface.
 */
export function instanceOfGlobalOptOut(value: object): value is GlobalOptOut {
    if (!('channel' in value) || value['channel'] === undefined) return false;
    if (!('endpoint' in value) || value['endpoint'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    return true;
}

export function GlobalOptOutFromJSON(json: any): GlobalOptOut {
    return GlobalOptOutFromJSONTyped(json, false);
}

export function GlobalOptOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalOptOut {
    if (json == null) {
        return json;
    }
    return {
        
        'channel': json['channel'],
        'endpoint': json['endpoint'],
        'createdDate': (new Date(json['created_date'])),
    };
}

export function GlobalOptOutToJSON(value?: GlobalOptOut | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'channel': value['channel'],
        'endpoint': value['endpoint'],
        'created_date': ((value['createdDate']).toISOString()),
    };
}

